import type {HelpFile} from '../../types/help'
import {CertificationPolicyWizardTestIds} from '../../../testids/CertificationPolicyWizardTestIds'

export const certificationPolicyWizardHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [CertificationPolicyWizardTestIds.certificationPolicyWizardPage]:
            'Erstellen oder bearbeiten Sie eine Zertifizierungsrichtlinie Schritt für Schritt: Grundlagen, Geltungsbereich, Prüfeinstellungen und Start.',
        [CertificationPolicyWizardTestIds.certificationPolicyWizardStepContainer]: null,
        [CertificationPolicyWizardTestIds.btnNextStep]: null,
        [CertificationPolicyWizardTestIds.btnPreviousStep]: null,
        [CertificationPolicyWizardTestIds.btnSaveAndReturn]:
            'Speichern Sie die Richtlinie und kehren Sie zur Übersichtsseite zurück, ohne eine Kampagne anzulegen.',
        [CertificationPolicyWizardTestIds.wizardDefaultPolicyInfo]: null,
        [CertificationPolicyWizardTestIds.wizardForbidden]: null,
    },
}
